import { Component, OnInit, OnChanges, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { EympService } from 'src/app/eymp-inszoom-integration/services/eympservice';
import { QuestInfoModel } from '../../../Model/QuestInfoModel';
import { NotifierService } from 'angular-notifier';
import { DestCompanies } from '../../../Model/DestCompanies';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-view-casetravel',
  templateUrl: './view-casetravel.component.html',
  styleUrls: ['./view-casetravel.component.scss']
})
export class ViewCasetravelComponent implements OnInit, OnChanges {

  @Input() documentInfo: QuestInfoModel;
  @Input() packagesStatus: any;
  @ViewChild('closeButton', { static: false }) closeButton: ElementRef;
  @ViewChild('addcloseButton', { static: false }) addcloseButton: ElementRef;
  @ViewChild('autocomplete', { static: false }) autocomplete: any;
  @Output() save = new EventEmitter<string>();
  errorMessage: string;
  public documents: QuestInfoModel;
  private notifier: NotifierService;
  public destinationCompanies: DestCompanies[] = [];
  public destinationCompanyCodes: DestCompanies[] = [];
  public isLoadingCompanies: boolean = false;
  public allCaseTypeData: any[] = [];
  public caseTypes: any[] = [];
  public caseSubTypes: any[] = [];
  public caseSubSubTypes: any[] = [];
  public zoomCaseType: string = '';
  public isCaseCreationInZoom: boolean = false;
  public isWaitingForMilestone: boolean = true;
  public isManualActionRequired: boolean = true;
  public originaldocumentInfo: QuestInfoModel;
  public userEmail: string = '';

  constructor(private eympservice: EympService, public notifierService: NotifierService, private authService: MsalService
  ) {
    this.notifier = notifierService;
    this.userEmail = authService.getAccount().userName;
  }

  ngOnInit(): void {
    console.log(this.documentInfo);
    console.log('ngOnInit');
  }
  ngOnChanges() {
    console.log(this.documentInfo);
    console.log('onchange');
  }
  closeForm() {
    const closeButton: HTMLElement = this.closeButton
      .nativeElement as HTMLElement;
    closeButton.click();
  }

  addcloseForm() {
    this.autocomplete.reset();
    const addcloseButton: HTMLElement = this.addcloseButton
      .nativeElement as HTMLElement;
    addcloseButton.click();
  }
  onPopupOpen() {
    this.originaldocumentInfo = JSON.parse(JSON.stringify(this.documentInfo));
    this.caseTypes = [];
    this.caseSubTypes = [];
    this.caseSubSubTypes = [];
    this.destinationCompanyCodes = [];
    this.destinationCompanies = [];
    if (this.packagesStatus === 'Ready for Profile and Case Creation') {
      this.isCaseCreationInZoom = true;
      this.isManualActionRequired = false;
      this.isWaitingForMilestone = false;
    }
    else if (this.packagesStatus === 'Failure') {
      this.isManualActionRequired = true;
      this.isWaitingForMilestone = false;
      this.isCaseCreationInZoom = false;
    }
    else if (this.packagesStatus === 'Waiting for Case Questionnaire milestone completion in EYMP') {
      this.isWaitingForMilestone = true;
      this.isManualActionRequired = false;
      this.isCaseCreationInZoom = false;
    }
    else {
      this.isWaitingForMilestone = false;
      this.isManualActionRequired = false;
      this.isCaseCreationInZoom = false;
    }
    this.fetchDestinationCompanyNames(this.documentInfo.clientName, this.documentInfo.serviceCountry);
    this.fetchDestinationCompanyCodes(this.documentInfo.clientName, this.documentInfo.serviceCountry);
    this.fetchCaseTypeDetails(
      this.documentInfo.clientGUID,
      this.documentInfo.clientName,
      this.documentInfo.serviceCountry,
      this.documentInfo.destCompanyCode
    );
  }
  fetchDestinationCompanyNames(clientName: string, serviceCountry: string) {
    this.isLoadingCompanies = true;
    this.eympservice.getDestCompanies(clientName, serviceCountry,'N')
      .subscribe(companies => {
        this.destinationCompanies = Array.isArray(companies) ? companies : (companies ? [companies] : []);
        this.isLoadingCompanies = false;
      }, error => {
        this.destinationCompanies = [];
        this.isLoadingCompanies = false;
      });
  }
  fetchDestinationCompanyCodes(clientName: string, serviceCountry: string) {
    this.eympservice.getDestCompanies(clientName, serviceCountry,'C')
      .subscribe(companies => {
        this.destinationCompanyCodes = Array.isArray(companies) ? companies : (companies ? [companies] : []);
      }, error => {
        this.destinationCompanyCodes = [];
      });
  }
  fetchCaseTypeDetails(clientGuid: string, clientName: string, serviceCountry: string, destCompCode: string) {
    console.log('Fetching case type details with:', clientGuid, clientName, serviceCountry, destCompCode);
    this.eympservice.getCaseTypeDetails(clientGuid, clientName, serviceCountry, destCompCode)
      .subscribe(data => {
        this.allCaseTypeData = Array.isArray(data) ? data : (data ? [data] : []);       
        this.caseTypes = Array.from(new Set(this.allCaseTypeData.map(x => x.caseType)))
          .map(type => ({ value: type, label: type }));
        // Restore Case Type selection if present
        if (this.documentInfo.caseType) {
          this.caseSubTypes = Array.from(
            new Set(
              this.allCaseTypeData
                .filter(x => x.caseType === this.documentInfo.caseType)
                .map(x => x.caseSubType)
            )
          ).map(sub => ({ value: sub, label: sub }));
        } else {
          this.caseSubTypes = [];
        }

        console.log('this.documentInfo.caseSubType', this.documentInfo.caseSubType);
        // Restore Sub Type selection if present
        if (this.documentInfo.caseType && this.documentInfo.caseSubType) {
          this.caseSubSubTypes = Array.from(
            new Set(
              this.allCaseTypeData
                .filter(x => x.caseType === this.documentInfo.caseType && x.caseSubType === this.documentInfo.caseSubType)
                .map(x => x.caseSubSubType)
            )
          ).map(subsub => ({ value: subsub, label: subsub }));
        }
        else if (this.documentInfo.caseType && (this.documentInfo.caseSubType === '' || this.documentInfo.caseSubType === null)) {
          this.caseSubSubTypes = Array.from(
            new Set(
              this.allCaseTypeData
                .filter(x => x.caseType === this.documentInfo.caseType && (x.caseSubType === '' || x.caseSubType === null))
                .map(x => x.caseSubSubType)
            )
          ).map(subsub => ({ value: subsub, label: subsub }));
        }
        else {
          this.caseSubSubTypes = [];
        }

        console.log('caseSubSubTypes:', this.caseSubSubTypes);
        console.log('documentInfo.caseSubSubType:', this.documentInfo.caseSubSubType);

        // Restore Zoom Case Type if all selections are present
        if (this.documentInfo.caseType && this.documentInfo.caseSubType && this.documentInfo.caseSubSubType) {
          const found = this.allCaseTypeData.find(
            x =>
              x.caseType === this.documentInfo.caseType &&
              x.caseSubType === this.documentInfo.caseSubType &&
              x.caseSubSubType === this.documentInfo.caseSubSubType
          );
          this.zoomCaseType = found ? found.zoomCaseType : '';
        }
        else if (this.documentInfo.caseType && this.documentInfo.caseSubType && (this.documentInfo.caseSubSubType === '' || this.documentInfo.caseSubSubType === null)) {
          const found = this.allCaseTypeData.find(
            x =>
              x.caseType === this.documentInfo.caseType &&
              x.caseSubType === this.documentInfo.caseSubType && (
              x.caseSubSubType === '' || x.caseSubSubType === null)
          );
          this.zoomCaseType = found ? found.zoomCaseType : '';
        }
        else if (this.documentInfo.caseType && (this.documentInfo.caseSubType === '' || this.documentInfo.caseSubType === null)
          && this.documentInfo.caseSubSubType) {
          const found = this.allCaseTypeData.find(
            x =>
              x.caseType === this.documentInfo.caseType &&
              (x.caseSubType === '' || x.caseSubType === null) &&
              (x.caseSubSubType === this.documentInfo.caseSubSubType)
          );
          this.zoomCaseType = found ? found.zoomCaseType : '';
        }
        else if (this.documentInfo.caseType && (this.documentInfo.caseSubType === '' || this.documentInfo.caseSubType === null)
          && (this.documentInfo.caseSubSubType === '' || this.documentInfo.caseSubSubType === null)) {
          const found = this.allCaseTypeData.find(
            x =>
              x.caseType === this.documentInfo.caseType &&
              (x.caseSubType === '' || x.caseSubType === null) &&
              (x.caseSubSubType === '' || x.caseSubSubType === null)
          );
          this.zoomCaseType = found ? found.zoomCaseType : '';
        }
        else {
          this.zoomCaseType = '';
        }
      });
  }

  onDestCompCodeChange() {
    this.fetchCaseTypeDetails(this.documentInfo.clientGUID, this.documentInfo.clientName, this.documentInfo.serviceCountry, this.documentInfo.destCompanyCode);
  }

  // On Case Type selection
  onCaseTypeChange() {
    this.caseSubTypes = Array.from(
      new Set(
        this.allCaseTypeData
          .filter(x => x.caseType === this.documentInfo.caseType)
          .map(x => x.caseSubType)
      )
    ).map(sub => ({ value: sub, label: sub }));

    this.caseSubSubTypes = Array.from(
      new Set(
        this.allCaseTypeData
          .filter(x => x.caseType === this.documentInfo.caseType) //&& x.caseSubSubType !=null && x.caseSubSubType !=''
          .map(x => x.caseSubSubType)
      )
    ).map(subsub => ({ value: subsub, label: subsub }));

    this.documentInfo.caseSubType = '';
    this.documentInfo.caseSubSubType = '';
    const zoomType = this.allCaseTypeData.find(
      x =>
        x.caseType === this.documentInfo.caseType &&
        (x.caseSubType === null || x.caseSubType === '') && (x.caseSubSubType === null || x.caseSubSubType === '')
    );
    this.zoomCaseType = zoomType ? zoomType.zoomCaseType : '';
}

  // On Sub Type selection
  onCaseSubTypeChange1() {
    if (this.documentInfo.caseSubType === null || this.documentInfo.caseSubType === 'null' || this.documentInfo.caseSubType === '') {
      this.caseSubSubTypes = Array.from(
        new Set(
          this.allCaseTypeData
            .filter(x => x.caseType === this.documentInfo.caseType && (x.caseSubType === '' || x.caseSubType === null))
            .map(x => x.caseSubSubType)
        )
      ).map(subsub => ({ value: subsub, label: subsub }));

      const zoomType = this.allCaseTypeData.find(
        x =>
          x.caseType === this.documentInfo.caseType &&
          x.caseSubType === ''
      );
      this.zoomCaseType = zoomType ? zoomType.zoomCaseType : '';
    }
    else {
      this.caseSubSubTypes = Array.from(
        new Set(
          this.allCaseTypeData
            .filter(x => x.caseType === this.documentInfo.caseType && x.caseSubType === this.documentInfo.caseSubType)
            .map(x => x.caseSubSubType)
        )
      ).map(subsub => ({ value: subsub, label: subsub }));
    }

    this.documentInfo.caseSubSubType = '';
    if (!this.documentInfo.caseSubSubType) {
      const zoomType = this.allCaseTypeData.find(
        x =>
          x.caseType === this.documentInfo.caseType &&
          x.caseSubType === this.documentInfo.caseSubType 
      );
      this.zoomCaseType = zoomType ? zoomType.zoomCaseType : '';
    } else {
      this.zoomCaseType = '';
    }
  }

  onCaseSubTypeChange() {
    if (
      this.documentInfo.caseSubType === null ||
      this.documentInfo.caseSubType === 'null' ||
      this.documentInfo.caseSubType === ''
    ) {
      this.caseSubSubTypes = Array.from(
        new Set(
          this.allCaseTypeData
            .filter(
              x =>
                x.caseType === this.documentInfo.caseType &&
                (x.caseSubType === '' || x.caseSubType === null)
            )
            .map(x => x.caseSubSubType)
        )
      ).map(subsub => ({ value: subsub, label: subsub }));

      const zoomType = this.allCaseTypeData.find(
        x => x.caseType === this.documentInfo.caseType && x.caseSubType === ''
      );
      this.zoomCaseType = zoomType ? zoomType.zoomCaseType : '';
    } else {
      this.caseSubSubTypes = Array.from(
        new Set(
          this.allCaseTypeData
            .filter(
              x =>
                x.caseType === this.documentInfo.caseType &&
                x.caseSubType === this.documentInfo.caseSubType
            )
            .map(x => x.caseSubSubType)
        )
      ).map(subsub => ({ value: subsub, label: subsub }));
    }

    // If there is exactly one sub sub type, set it as default
    if (this.caseSubSubTypes.length === 1) {
      this.documentInfo.caseSubSubType = this.caseSubSubTypes[0].value;
      console.log('this.caseSubSubTypes[0].value', this.caseSubSubTypes[0].value);
    } else {
      this.documentInfo.caseSubSubType = '';
    }

    // If no sub sub type, set zoom case type
    if (!this.documentInfo.caseSubSubType) {
      const zoomType = this.allCaseTypeData.find(
        x =>
          x.caseType === this.documentInfo.caseType &&
          x.caseSubType === this.documentInfo.caseSubType
      );
      this.zoomCaseType = zoomType ? zoomType.zoomCaseType : '';
    } else {
      this.zoomCaseType = '';
    }
  }



  // On Sub Sub Type selection
  onCaseSubSubTypeChange() {
    if ((this.documentInfo.caseSubType === '' || this.documentInfo.caseSubType === null || this.documentInfo.caseSubType === 'null')
      && (this.documentInfo.caseSubSubType != '' && this.documentInfo.caseSubSubType != 'null' || this.documentInfo.caseSubType != null)) {
      const zoomcase1 = this.allCaseTypeData.find(
        x =>
          x.caseType === this.documentInfo.caseType &&
          (x.caseSubType === '' || x.caseSubType === null) &&
          x.caseSubSubType === this.documentInfo.caseSubSubType
      );
      this.zoomCaseType = zoomcase1 ? zoomcase1.zoomCaseType : '';
    }
    if ((this.documentInfo.caseSubType != '' && this.documentInfo.caseSubType != null && this.documentInfo.caseSubType != 'null')
      && (this.documentInfo.caseSubSubType === '' || this.documentInfo.caseSubSubType === 'null' || this.documentInfo.caseSubType === null))
    {
      const zoomcase2 = this.allCaseTypeData.find(
        x =>
          x.caseType === this.documentInfo.caseType &&
          (x.caseSubType === this.documentInfo.caseSubType) &&
          x.caseSubSubType === this.documentInfo.caseSubSubType
      );
      this.zoomCaseType = zoomcase2 ? zoomcase2.zoomCaseType : '';
    }
    else {
      const zoomcase3 = this.allCaseTypeData.find(
        x =>
          x.caseType === this.documentInfo.caseType &&
          x.caseSubType === this.documentInfo.caseSubType &&
          x.caseSubSubType === this.documentInfo.caseSubSubType
      );
      this.zoomCaseType = zoomcase3 ? zoomcase3.zoomCaseType : '';
    }
  }

  private buildSavePayload(): any {
    if (this.isWaitingForMilestone) {
      return {
        id: this.documentInfo.id,
        travelPathwayID: this.documentInfo.travelPathwayID,
        clientName: this.documentInfo.clientName,
        applicantName: this.documentInfo.applicantName,
        eympCaseID: this.documentInfo.eympCaseID,
        homeCompanyName: this.documentInfo.homeCompanyName,
        destCompanyCode: this.documentInfo.destCompanyCode,
        zoomProfileID: this.documentInfo.zoomProfileID,
        zoomCaseID: this.documentInfo.zoomCaseID
      };
    } else if (this.isCaseCreationInZoom) {
      return {
        id: this.documentInfo.id,
        travelPathwayID: this.documentInfo.travelPathwayID,
        clientName: this.documentInfo.clientName,
        applicantName: this.documentInfo.applicantName,
        eympCaseID: this.documentInfo.eympCaseID,
        homeCompanyName: this.documentInfo.homeCompanyName,
        destCompanyCode: this.documentInfo.destCompanyCode,
        destinationCompanyName: this.documentInfo.destinationCompanyName,
        caseType: this.documentInfo.caseType,
        caseSubType: this.documentInfo.caseSubType,
        caseSubSubType: this.documentInfo.caseSubSubType,
        zoomCaseType: this.zoomCaseType
      };
    } else if (this.isManualActionRequired) {
      return {
        id: this.documentInfo.id,
        travelPathwayID: this.documentInfo.travelPathwayID,
        clientName: this.documentInfo.clientName,
        applicantName: this.documentInfo.applicantName,
        eympCaseID: this.documentInfo.eympCaseID,
        homeCompanyName: this.documentInfo.homeCompanyName,
        destCompanyCode: this.documentInfo.destCompanyCode,
        destinationCompanyName: this.documentInfo.destinationCompanyName,
        zoomProfileID: this.documentInfo.zoomProfileID,
        zoomCaseID: this.documentInfo.zoomCaseID,
        caseType: this.documentInfo.caseType,
        caseSubType: this.documentInfo.caseSubType,
        caseSubSubType: this.documentInfo.caseSubSubType,
        zoomCaseType: this.zoomCaseType
      };
    }
    // Default: save nothing or all, as needed
    return this.documentInfo;
  }



  saveData() {

    const payload = this.buildSavePayload();

    const changedFields: Array<{ field: string, before: any, after: any }> = [];
    Object.keys(this.documentInfo).forEach(key => {
      if (this.documentInfo[key] !== this.originaldocumentInfo[key]) {
        changedFields.push({
          field: key,
          before: this.originaldocumentInfo[key],
          after: this.documentInfo[key]
        });
      }
    });


    console.log('changedFields', changedFields);

    this.eympservice.SaveDocumentExtraction(payload, this.userEmail, changedFields).subscribe((result) => {
      document.getElementById("btnClose").click();
      this.closeForm();
      this.notifier.notify('success', 'Case details have been updated successfully');
      this.save.emit("refresh");
    }, error => {
      this.notifier.notify('error', 'Error occured while updating case details');
    });
  }

}
